import { ReactComponent as CicleNotch } from '~assets/icons/circle-notch.svg';

import * as styled from './styled';

function LoadingSpinner() {
  return (
    <>
      <styled.Wrapper>
        <CicleNotch />
      </styled.Wrapper>
    </>
  );
}

export default LoadingSpinner;
